import { QrCodeDisplay, QrCodeDisplayLoader } from './QrCodeDisplay';


export const qrCodePOSRouter = {
  path: '/qr_code_pos/:event_id/:uid',
  id: 'qrcode-pos',
  loader: QrCodeDisplayLoader,
  element: <QrCodeDisplay />,
};
